import { render, staticRenderFns } from "./FightForm.vue?vue&type=template&id=7978cb08&"
import script from "./FightForm.vue?vue&type=script&lang=js&"
export * from "./FightForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports